export default __webpack_public_path__ + "static/media/1.2e2ed8be.mp4";